import { Typography } from '@mui/material';
import React from 'react';

function MUITypography(props) {
  const { label, children, style, ...rest } = props;

  const isHTML = typeof label === 'string' && /<[^>]+>/.test(label);

  if (isHTML) {
    // Render HTML string — DO NOT pass children
    return (
      <Typography
        variant={props?.variant }
        style={style}
        {...rest}
        // important: pass only the html prop, no children
        dangerouslySetInnerHTML={{ __html: label }}
      />
    );
  }

  // Normal rendering with children/label
  return (
    <Typography  
      variant={props?.variant }
      style={style} {...rest}>
        {label ?? children}
    </Typography>
  );
}

export default MUITypography;
